import { ArrayHelpers, FieldArray } from 'formik';
import React, { useRef } from 'react';
import { Button, Form } from 'antd';
import { Select } from 'formik-antd';

import { useHistory } from 'react-router-dom';
import { useStore } from '../../../../store';
import createSortSelectData from '../../../../utils/create-sort-select-data';
import { ReactComponent as ThrashCan } from '../../../../assets/icons/thrashCan.svg';
import { useFilterSortContext } from '../context/filter-sort-context';
import { useActions } from '../../../providers/actions-provider/actions.context';
import { useMapContext } from '../context/map-context';

const { Option } = Select;
interface IProps {
  notEditable?:boolean
}
export const SortComponent:React.FC<IProps> = ({ notEditable = false }) => {
  const { formik, setSortOpened, createSortObj } = useFilterSortContext();
  const { skip, configurationValues: { pageSize } } = useMapContext();
  const {
    executedReport,
  } = useStore();

  const { reportActions } = useActions();
  const { location: { pathname } } = useHistory();
  const { find } = executedReport.data;
  const reportCode = pathname.split('/')[4];
  const {
    values, dirty,
  } = formik;
  const sortsRef = useRef<FieldArrayRef>(null);
/* eslint-disable */
  interface IFieldArrayRefProps {
    fieldArrayHelpers: ArrayHelpers;
    values: any;
    dirty: boolean;
    children?: React.ReactNode;
  }
  class FieldArrayRef extends React.Component<IFieldArrayRefProps> {
    addItem(value: any) {
      const { fieldArrayHelpers: { push } } = this.props;
      push(value);
    }

    isDirty() {
      return this.props.dirty;
    }

    render() {
      return (
        <>
          {this.props.children}
        </>
      );
    }
  }





  

  return (
    <Form style={{ width: '100%', display:"flex", flexDirection:"column", gap:"16px",padding:"16px", backgroundColor:"white" }}>

      <span style={{ fontSize: '14px', fontWeight: 400 }}>Sorting by:</span>
      <div style={{display:"flex", flexDirection:"column", gap:"16px", maxHeight:"200px", overflow:"scroll"}}>
      <FieldArray
        name="sorts"
        render={(sortsArrayHelpers: ArrayHelpers) => (
          (
            <FieldArrayRef
              ref={sortsRef}
              fieldArrayHelpers={sortsArrayHelpers}
              values={values}
              dirty={dirty}
            >
              {values.sorts && values.sorts.map(
                (sort: string, sortIdx: number) => {
                  return (
                  <div
                    // eslint-disable-next-line
                    key={`sort-select-${sortIdx}`}
                    style={{ display: 'flex', flexDirection:"row" }}
                  >
                    <Select
                      disabled={notEditable}
                      name={`sorts.${sortIdx}`}
                      size="large"
                      className="ant__select"
                      style={{ width: '100%' }}
                    >
                      {createSortSelectData(executedReport.data.columns || [], sort).map((item, optIdx) =>  (
                        <Option
                          value={item.value}
                          // eslint-disable-next-line
                          key={`sort-option-${optIdx}`}
                        >
                          {item.label}
                        </Option>
                        )
                         )}
                      <Option
                        value=""
                        key="sort-option-none"
                      >
                        None
                      </Option>
                    </Select>
                    <button
                      disabled={notEditable}
                      type="button"
                      onClick={() => {
                        sortsArrayHelpers.remove(sortIdx);
                      }}
                      style={{ float: 'left' }}
                    >
                      {notEditable ? '' : <ThrashCan /> }
                    </button>
                  </div>
                )},
              )}
            </FieldArrayRef>
          )
        )}
      />
      </div>
      <div style={{display:"flex", flexDirection:"row", justifyContent:"space-between"}}>
      <Button
      disabled={notEditable}
      onClick={(event) => {
        sortsRef.current?.addItem('');
        event.stopPropagation();
        event.preventDefault();
      }}
      style={{fontSize:"12px", fontWeight:500}}
    >
       + New sort
    </Button>
    <Button
      type="primary"
      style={{fontSize:"12px", fontWeight:500, height:"32px"}}
      onClick={() => {
        setSortOpened(false);
        reportActions.getMapReport(reportCode, find, createSortObj(values.sorts), skip, pageSize as number);
      }}
      >
      Execute
    </Button>
      </div>
      </Form>
  );
};
